import { addI18n } from "tinymce/tinymce";

addI18n("de", {
  Redo: "Redo",
  Undo: "R\xfcckg\xe4ngig machen",
  Cut: "Ausschneiden",
  Copy: "Kopieren",
  Paste: "Einf\xfcgen",
  "Select all": "Alles ausw\xe4hlen",
  "New document": "Neues Dokument",
  Ok: "Ok",
  Cancel: "Abbrechen",
  "Visual aids": "Visuelle Hilfen",
  Bold: "Fett",
  Italic: "Kursiv",
  Underline: "Unterstrichen",
  Strikethrough: "Durchgestrichen",
  Superscript: "Hochgestellt",
  Subscript: "Tiefgestellt",
  "Clear formatting": "Formatierung entfernen",
  Remove: "Entfernen",
  "Align left": "Linksb\xfcndig ausrichten",
  "Align center": "Zentrieren",
  "Align right": "Rechtsb\xfcndig ausrichten",
  "No alignment": "Keine Ausrichtung",
  Justify: "Blocksatz",
  "Bullet list": "Aufz\xe4hlung",
  "Numbered list": "Nummerierte Liste",
  "Decrease indent": "Einzug verkleinern",
  "Increase indent": "Einzug vergr\xf6\xdfern",
  Close: "Schlie\xdfen",
  Formats: "Formate",
  "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.":
    "Ihr Browser unterst\xfctzt leider keinen direkten Zugriff auf die Zwischenablage. Bitte benutzen Sie die Tastenkombinationen Strg+X/C/V.",
  Headings: "\xdcberschriften",
  "Heading 1": "\xdcberschrift 1",
  "Heading 2": "\xdcberschrift 2",
  "Heading 3": "\xdcberschrift 3",
  "Heading 4": "\xdcberschrift 4",
  "Heading 5": "\xdcberschrift 5",
  "Heading 6": "\xdcberschrift 6",
  Preformatted: "Vorformatiert",
  Div: "Div",
  Pre: "Pre",
  Code: "Code",
  Paragraph: "Absatz",
  Blockquote: "Blockzitat",
  Inline: "Zeichenformate",
  Blocks: "Bl\xf6cke",
  "Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.":
    "Einf\xfcgen ist nun im unformatierten Textmodus. Inhalte werden ab jetzt als unformatierter Text eingef\xfcgt, bis Sie diese Einstellung wieder deaktivieren.",
  Fonts: "Schriftarten",
  "Font sizes": "Schriftgr\xf6\xdfen",
  Class: "Klasse",
  "Browse for an image": "Bild...",
  OR: "ODER",
  "Drop an image here": "Bild hier ablegen",
  Upload: "Hochladen",
  "Uploading image": "Bild wird hochgeladen",
  Block: "Blocksatz",
  Align: "Ausrichtung",
  Default: "Standard",
  Circle: "Kreis",
  Disc: "Scheibe",
  Square: "Rechteck",
  "Lower Alpha": "Lateinisches Alphabet in Kleinbuchstaben",
  "Lower Greek": "Griechische Kleinbuchstaben",
  "Lower Roman": "Kleiner r\xf6mischer Buchstabe",
  "Upper Alpha": "Lateinisches Alphabet in Gro\xdfbuchstaben",
  "Upper Roman": "Gro\xdfer r\xf6mischer Buchstabe",
  "Anchor...": "Textmarke",
  Anchor: "Anker",
  Name: "Name",
  ID: "ID",
  "ID should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.":
    "Die ID muss mit einem Buchstaben beginnen gefolgt von Buchstaben, Zahlen, Bindestrichen, Punkten, Doppelpunkten oder Unterstrichen.",
  "You have unsaved changes are you sure you want to navigate away?":
    "Die \xc4nderungen wurden noch nicht gespeichert. Sind Sie sicher, dass Sie diese Seite verlassen wollen?",
  "Restore last draft": "Letzten Entwurf wiederherstellen",
  "Special character...": "Sonderzeichen...",
  "Special Character": "Sonderzeichen",
  "Source code": "Quellcode",
  "Insert/Edit code sample": "Codebeispiel einf\xfcgen/bearbeiten",
  Language: "Sprache",
  "Code sample...": "Codebeispiel...",
  "Left to right": "Von links nach rechts",
  "Right to left": "Von rechts nach links",
  Title: "Titel",
  Fullscreen: "Vollbild",
  Action: "Aktion",
  Shortcut: "Tastenkombination",
  Help: "Hilfe",
  Address: "Adresse",
  "Focus to menubar": "Fokus auf Men\xfcleiste",
  "Focus to toolbar": "Fokus auf Symbolleiste",
  "Focus to element path": "Fokus auf Elementpfad",
  "Focus to contextual toolbar": "Fokus auf kontextbezogene Symbolleiste",
  "Insert link (if link plugin activated)": "Link einf\xfcgen (wenn Link-Plugin aktiviert ist)",
  "Save (if save plugin activated)": "Speichern (wenn Save-Plugin aktiviert ist)",
  "Find (if searchreplace plugin activated)": "Suchen (wenn Suchen/Ersetzen-Plugin aktiviert ist)",
  "Plugins installed ({0}):": "Installierte Plugins ({0}):",
  "Premium plugins:": "Premium-Plugins:",
  "Learn more...": "Erfahren Sie mehr dazu...",
  "You are using {0}": "Sie verwenden {0}",
  Plugins: "Plugins",
  "Handy Shortcuts": "Praktische Tastenkombinationen",
  "Horizontal line": "Horizontale Linie",
  "Insert/edit image": "Bild einf\xfcgen/bearbeiten",
  "Alternative description": "Alternative Beschreibung",
  Accessibility: "Barrierefreiheit",
  "Image is decorative": "Bild ist dekorativ",
  Source: "Quelle",
  Dimensions: "Abmessungen",
  "Constrain proportions": "Seitenverh\xe4ltnis beibehalten",
  General: "Allgemein",
  Advanced: "Erweitert",
  Style: "Formatvorlage",
  "Vertical space": "Vertikaler Raum",
  "Horizontal space": "Horizontaler Raum",
  Border: "Rahmen",
  "Insert image": "Bild einf\xfcgen",
  "Image...": "Bild...",
  "Image list": "Bildliste",
  Resize: "Skalieren",
  "Insert date/time": "Datum/Uhrzeit einf\xfcgen",
  "Date/time": "Datum/Uhrzeit",
  "Insert/edit link": "Link einf\xfcgen/bearbeiten",
  "Text to display": "Anzuzeigender Text",
  Url: "URL",
  "Open link in...": "Link \xf6ffnen in...",
  "Current window": "Aktuelles Fenster",
  None: "Keine",
  "New window": "Neues Fenster",
  "Open link": "Link \xf6ffnen",
  "Remove link": "Link entfernen",
  Anchors: "Anker",
  "Link...": "Link...",
  "Paste or type a link": "Link einf\xfcgen oder eingeben",
  "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?":
    "Diese URL scheint eine E-Mail-Adresse zu sein. M\xf6chten Sie das dazu ben\xf6tigte mailto: voranstellen?",
  "The URL you entered seems to be an external link. Do you want to add the required http:// prefix?":
    "Diese URL scheint ein externer Link zu sein. M\xf6chten Sie das dazu ben\xf6tigte http:// voranstellen?",
  "The URL you entered seems to be an external link. Do you want to add the required https:// prefix?":
    "Die eingegebene URL scheint ein externer Link zu sein. Soll das fehlende https:// davor erg\xe4nzt werden?",
  "Link list": "Linkliste",
  "Insert video": "Video einf\xfcgen",
  "Insert/edit video": "Video einf\xfcgen/bearbeiten",
  "Insert/edit media": "Medien einf\xfcgen/bearbeiten",
  "Alternative source": "Alternative Quelle",
  "Alternative source URL": "URL der alternativen Quelle",
  "Media poster (Image URL)": "Medienposter (Bild-URL)",
  "Paste your embed code below:": "F\xfcgen Sie Ihren Einbettungscode unten ein:",
  Embed: "Einbettung",
  "Media...": "Medien...",
  "Nonbreaking space": "Gesch\xfctztes Leerzeichen",
  "Page break": "Seitenumbruch",
  "Paste as text": "Als Text einf\xfcgen",
  Preview: "Vorschau",
  Print: "Drucken",
  "Print...": "Drucken...",
  Save: "Speichern",
  Find: "Suchen",
  "Replace with": "Ersetzen durch",
  Replace: "Ersetzen",
  "Replace all": "Alle ersetzen",
  Previous: "Vorherige",
  Next: "N\xe4chste",
  "Find and Replace": "Suchen und Ersetzen",
  "Find and replace...": "Suchen und ersetzen...",
  "Could not find the specified string.": "Die angegebene Zeichenfolge wurde nicht gefunden.",
  "Match case": "Gro\xdf-/Kleinschreibung beachten",
  "Find whole words only": "Nur ganze W\xf6rter suchen",
  "Find in selection": "In Auswahl suchen",
  "Insert table": "Tabelle einf\xfcgen",
  "Table properties": "Tabelleneigenschaften",
  "Delete table": "Tabelle l\xf6schen",
  Cell: "Zelle",
  Row: "Zeile",
  Column: "Spalte",
  "Cell properties": "Zelleigenschaften",
  "Merge cells": "Zellen verbinden",
  "Split cell": "Zelle aufteilen",
  "Insert row before": "Neue Zeile davor einf\xfcgen",
  "Insert row after": "Neue Zeile danach einf\xfcgen",
  "Delete row": "Zeile l\xf6schen",
  "Row properties": "Zeileneigenschaften",
  "Cut row": "Zeile ausschneiden",
  "Cut column": "Spalte ausschneiden",
  "Copy row": "Zeile kopieren",
  "Copy column": "Spalte kopieren",
  "Paste row before": "Zeile davor einf\xfcgen",
  "Paste column before": "Spalte davor einf\xfcgen",
  "Paste row after": "Zeile danach einf\xfcgen",
  "Paste column after": "Spalte danach einf\xfcgen",
  "Insert column before": "Neue Spalte davor einf\xfcgen",
  "Insert column after": "Neue Spalte danach einf\xfcgen",
  "Delete column": "Spalte l\xf6schen",
  Cols: "Spalten",
  Rows: "Zeilen",
  Width: "Breite",
  Height: "H\xf6he",
  "Cell spacing": "Zellenabstand",
  "Cell padding": "Zelleninnenabstand",
  "Row clipboard actions": "Zeilen-Zwischenablage-Aktionen",
  "Column clipboard actions": "Spalten-Zwischenablage-Aktionen",
  "Table styles": "Tabellenstil",
  "Cell styles": "Zellstil",
  "Column header": "Spaltenkopf",
  "Row header": "Zeilenkopf",
  "Table caption": "Tabellenbeschriftung",
  Caption: "Beschriftung",
  "Show caption": "Beschriftung anzeigen",
  Left: "Links",
  Center: "Zentriert",
  Right: "Rechts",
  "Cell type": "Zelltyp",
  Scope: "Bereich",
  Alignment: "Ausrichtung",
  "Horizontal align": "Horizontal ausrichten",
  "Vertical align": "Vertikal ausrichten",
  Top: "Oben",
  Middle: "Mitte",
  Bottom: "Unten",
  "Header cell": "Kopfzelle",
  "Row group": "Zeilengruppe",
  "Column group": "Spaltengruppe",
  "Row type": "Zeilentyp",
  Header: "Kopfzeile",
  Body: "Inhalt",
  Footer: "Fu\xdfzeile",
  "Border color": "Rahmenfarbe",
  Solid: "Durchgezogen",
  Dotted: "Gepunktet",
  Dashed: "Gestrichelt",
  Double: "Doppelt",
  Groove: "Gekantet",
  Ridge: "Eingeritzt",
  Inset: "Eingelassen",
  Outset: "Hervorstehend",
  Hidden: "Unsichtbar",
  "Insert template...": "Vorlage einf\xfcgen...",
  Templates: "Vorlagen",
  Template: "Vorlage",
  "Insert Template": "Vorlage einf\xfcgen",
  "Text color": "Textfarbe",
  "Background color": "Hintergrundfarbe",
  "Custom...": "Benutzerdefiniert...",
  "Custom color": "Benutzerdefinierte Farbe",
  "No color": "Keine Farbe",
  "Remove color": "Farbauswahl aufheben",
  "Show blocks": "Bl\xf6cke anzeigen",
  "Show invisible characters": "Unsichtbare Zeichen anzeigen",
  "Word count": "Anzahl der W\xf6rter",
  Count: "Anzahl",
  Document: "Dokument",
  Selection: "Auswahl",
  Words: "W\xf6rter",
  "Words: {0}": "Wortzahl: {0}",
  "{0} words": "{0} W\xf6rter",
  File: "Datei",
  Edit: "Bearbeiten",
  Insert: "Einf\xfcgen",
  View: "Ansicht",
  Format: "Format",
  Table: "Tabelle",
  Tools: "Werkzeuge",
  "Powered by {0}": "Betrieben von {0}",
  "Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help":
    "Rich-Text-Bereich. Dr\xfccken Sie Alt+F9 f\xfcr das Men\xfc. Dr\xfccken Sie Alt+F10 f\xfcr die Symbolleiste. Dr\xfccken Sie Alt+0 f\xfcr Hilfe.",
  "Image title": "Bildtitel",
  "Border width": "Rahmenbreite",
  "Border style": "Rahmenstil",
  Error: "Fehler",
  Warn: "Warnung",
  Valid: "G\xfcltig",
  "To open the popup, press Shift+Enter":
    "Dr\xfccken Sie Umschalt+Eingabe, um das Popup-Fenster zu \xf6ffnen.",
  "Rich Text Area": "Rich-Text-Area",
  "Rich Text Area. Press ALT-0 for help.": "Rich-Text-Bereich. Dr\xfccken Sie Alt+0 f\xfcr Hilfe.",
  "System Font": "Betriebssystemschriftart",
  "Failed to upload image: {0}": "Bild konnte nicht hochgeladen werden: {0}",
  "Failed to load plugin: {0} from url {1}": "Plugin konnte nicht geladen werden: {0} von URL {1}",
  "Failed to load plugin url: {0}": "Plugin-URL konnte nicht geladen werden: {0}",
  "Failed to initialize plugin: {0}": "Plugin konnte nicht initialisiert werden: {0}",
  example: "Beispiel",
  Search: "Suchen",
  All: "Alle",
  Currency: "W\xe4hrung",
  Text: "Text",
  Quotations: "Anf\xfchrungszeichen",
  Mathematical: "Mathematisch",
  "Extended Latin": "Erweitertes Latein",
  Symbols: "Symbole",
  Arrows: "Pfeile",
  "User Defined": "Benutzerdefiniert",
  "dollar sign": "Dollarzeichen",
  "currency sign": "W\xe4hrungssymbol",
  "euro-currency sign": "Eurozeichen",
  "colon sign": "Doppelpunkt",
  "cruzeiro sign": "Cruzeirozeichen",
  "french franc sign": "Franczeichen",
  "lira sign": "Lirezeichen",
  "mill sign": "Millzeichen",
  "naira sign": "Nairazeichen",
  "peseta sign": "Pesetazeichen",
  "rupee sign": "Rupiezeichen",
  "won sign": "Wonzeichen",
  "new sheqel sign": "Schekelzeichen",
  "dong sign": "Dongzeichen",
  "kip sign": "Kipzeichen",
  "tugrik sign": "Tugrikzeichen",
  "drachma sign": "Drachmezeichen",
  "german penny symbol": "Pfennigzeichen",
  "peso sign": "Pesozeichen",
  "guarani sign": "Guaranizeichen",
  "austral sign": "Australzeichen",
  "hryvnia sign": "Hrywnjazeichen",
  "cedi sign": "Cedizeichen",
  "livre tournois sign": "Livrezeichen",
  "spesmilo sign": "Spesmilozeichen",
  "tenge sign": "Tengezeichen",
  "indian rupee sign": "Indisches Rupiezeichen",
  "turkish lira sign": "T\xfcrkisches Lirazeichen",
  "nordic mark sign": "Zeichen nordische Mark",
  "manat sign": "Manatzeichen",
  "ruble sign": "Rubelzeichen",
  "yen character": "Yenzeichen",
  "yuan character": "Yuanzeichen",
  "yuan character, in hong kong and taiwan": "Yuanzeichen in Hongkong und Taiwan",
  "yen/yuan character variant one": "Yen-/Yuanzeichen Variante 1",
  Emojis: "Emojis",
  "Emojis...": "Emojis...",
  "Loading emojis...": "Lade Emojis...",
  "Could not load emojis": "Emojis konnten nicht geladen werden",
  People: "Menschen",
  "Animals and Nature": "Tiere und Natur",
  "Food and Drink": "Essen und Trinken",
  Activity: "Aktivit\xe4t",
  "Travel and Places": "Reisen und Orte",
  Objects: "Objekte",
  Flags: "Flaggen",
  Characters: "Zeichen",
  "Characters (no spaces)": "Zeichen (ohne Leerzeichen)",
  "{0} characters": "{0}\xa0Zeichen",
  "Error: Form submit field collision.": "Fehler: Kollision der Formularbest\xe4tigungsfelder.",
  "Error: No form element found.": "Fehler: Kein Formularelement gefunden.",
  "Color swatch": "Farbpalette",
  "Color Picker": "Farbwahl",
  "Invalid hex color code: {0}": "Ung\xfcltiger Hexadezimal-Farbwert: {0}",
  "Invalid input": "Ung\xfcltige Eingabe",
  R: "R",
  "Red component": "Rotanteil",
  G: "G",
  "Green component": "Gr\xfcnanteil",
  B: "B",
  "Blue component": "Blauanteil",
  "#": "#",
  "Hex color code": "Hexadezimal-Farbwert",
  "Range 0 to 255": "Spanne 0 bis 255",
  Turquoise: "T\xfcrkis",
  Green: "Gr\xfcn",
  Blue: "Blau",
  Purple: "Violett",
  "Navy Blue": "Marineblau",
  "Dark Turquoise": "Dunkelt\xfcrkis",
  "Dark Green": "Dunkelgr\xfcn",
  "Medium Blue": "Mittleres Blau",
  "Medium Purple": "Mittelviolett",
  "Midnight Blue": "Mitternachtsblau",
  Yellow: "Gelb",
  Orange: "Orange",
  Red: "Rot",
  "Light Gray": "Hellgrau",
  Gray: "Grau",
  "Dark Yellow": "Dunkelgelb",
  "Dark Orange": "Dunkelorange",
  "Dark Red": "Dunkelrot",
  "Medium Gray": "Mittelgrau",
  "Dark Gray": "Dunkelgrau",
  "Light Green": "Hellgr\xfcn",
  "Light Yellow": "Hellgelb",
  "Light Red": "Hellrot",
  "Light Purple": "Helllila",
  "Light Blue": "Hellblau",
  "Dark Purple": "Dunkellila",
  "Dark Blue": "Dunkelblau",
  Black: "Schwarz",
  White: "Wei\xdf",
  "Switch to or from fullscreen mode": "Vollbildmodus umschalten",
  "Open help dialog": "Hilfe-Dialog \xf6ffnen",
  history: "Historie",
  styles: "Stile",
  formatting: "Formatierung",
  alignment: "Ausrichtung",
  indentation: "Einr\xfcckungen",
  Font: "Schriftart",
  Size: "Schriftgr\xf6\xdfe",
  "More...": "Mehr...",
  "Select...": "Auswahl...",
  Preferences: "Einstellungen",
  Yes: "Ja",
  No: "Nein",
  "Keyboard Navigation": "Tastaturnavigation",
  Version: "Version",
  "Code view": "Code Ansicht",
  "Open popup menu for split buttons": "\xd6ffne Popup Menge um Buttons zu trennen",
  "List Properties": "Liste Eigenschaften",
  "List properties...": "Liste Eigenschaften",
  "Start list at number": "Beginne Liste mit Nummer",
  "Line height": "Liniendicke",
  "Dropped file type is not supported": "Hereingezogener Dateityp wird nicht unterst\xfctzt",
  "Loading...": "Wird geladen...",
  "ImageProxy HTTP error: Rejected request": "Image Proxy HTTP Fehler: Abgewiesene Anfrage",
  "ImageProxy HTTP error: Could not find Image Proxy":
    "Image Proxy HTTP Fehler: Kann Image Proxy nicht finden",
  "ImageProxy HTTP error: Incorrect Image Proxy URL":
    "Image Proxy HTTP Fehler: Falsche Image Proxy URL",
  "ImageProxy HTTP error: Unknown ImageProxy error":
    "Image Proxy HTTP Fehler: Unbekannter Image Proxy Fehler",
});

addI18n("es", {
  Redo: "Restablecer",
  Undo: "Deshacer",
  Cut: "Cortar",
  Copy: "Copiar",
  Paste: "Pegar",
  "Select all": "Seleccionar todo",
  "New document": "Nuevo documento",
  Ok: "Aceptar",
  Cancel: "Cancelar",
  "Visual aids": "Ayudas visuales",
  Bold: "Negrita",
  Italic: "Cursiva",
  Underline: "Subrayado",
  Strikethrough: "Tachado",
  Superscript: "Superíndice",
  Subscript: "Subíndice",
  "Clear formatting": "Borrar formato",
  Remove: "Eliminar",
  "Align left": "Alinear a la izquierda",
  "Align center": "Centrar",
  "Align right": "Alinear a la derecha",
  "No alignment": "Sin alineación",
  Justify: "Justificar",
  "Bullet list": "Lista de viñetas",
  "Numbered list": "Lista numerada",
  "Decrease indent": "Disminuir sangría",
  "Increase indent": "Aumentar sangría",
  Close: "Cerrar",
  Formats: "Formatos",
  "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.":
    "Tu navegador no admite el acceso directo al portapapeles. Usa los atajos de teclado Ctrl+X/C/V en su lugar.",
  Headings: "Encabezados",
  "Heading 1": "Encabezado 1",
  "Heading 2": "Encabezado 2",
  "Heading 3": "Encabezado 3",
  "Heading 4": "Encabezado 4",
  "Heading 5": "Encabezado 5",
  "Heading 6": "Encabezado 6",
  Preformatted: "Preformateado",
  Div: "Div",
  Pre: "Preformateado",
  Code: "Código",
  Paragraph: "Párrafo",
  Blockquote: "Cita en bloque",
  Inline: "En línea",
  Blocks: "Bloques",
  "Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.":
    "El pegado ahora está en modo de texto sin formato. El contenido se pegará como texto sin formato hasta que desactives esta opción.",
  Fonts: "Fuentes",
  "Font sizes": "Tamaños de fuente",
  Class: "Clase",
  "Browse for an image": "Buscar una imagen",
  OR: "O",
  "Drop an image here": "Arrastra una imagen aquí",
  Upload: "Subir",
  "Uploading image": "Subiendo imagen",
  Block: "Bloque",
  Align: "Alinear",
  Default: "Por defecto",
  Circle: "Círculo",
  Disc: "Disco",
  Square: "Cuadrado",
  "Lower Alpha": "Minúscula alfabética",
  "Lower Greek": "Minúscula griega",
  "Lower Roman": "Minúscula romana",
  "Upper Alpha": "Mayúscula alfabética",
  "Upper Roman": "Mayúscula romana",
  "Anchor...": "Ancla...",
  Anchor: "Ancla",
  Name: "Nombre",
  ID: "ID",
  "ID should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.":
    "El ID debe comenzar con una letra, seguida solo de letras, números, guiones, puntos, dos puntos o guiones bajos.",
  "You have unsaved changes are you sure you want to navigate away?":
    "Tienes cambios sin guardar, ¿estás seguro de que quieres salir?",
  "Restore last draft": "Restaurar el último borrador",
  "Special character...": "Carácter especial...",
  "Special Character": "Carácter especial",
  "Source code": "Código fuente",
  "Insert/Edit code sample": "Insertar / Editar muestra de código",
  Language: "Idioma",
  "Code sample...": "Muestra de código...",
  "Left to right": "De izquierda a derecha",
  "Right to left": "De derecha a izquierda",
  Title: "Título",
  Fullscreen: "Pantalla completa",
  Action: "Acción",
  Shortcut: "Atajo",
  Help: "Ayuda",
  Address: "Dirección",
  "Focus to menubar": "Enfocar a la barra de menú",
  "Focus to toolbar": "Enfocar a la barra de herramientas",
  "Focus to element path": "Enfocar a la ruta del elemento",
  "Focus to contextual toolbar": "Enfocar a la barra de herramientas contextual",
  "Insert link (if link plugin activated)":
    "Insertar enlace (si el plugin de enlace está activado)",
  "Save (if save plugin activated)": "Guardar (si el plugin de guardar está activado)",
  "Find (if searchreplace plugin activated)":
    "Buscar (si el plugin de buscar y reemplazar está activado)",
  "Plugins installed ({0}):": "Plugins instalados ({0}):",
  "Premium plugins:": "Plugins premium:",
  "Learn more...": "Saber más...",
  "You are using {0}": "Estás usando {0}",
  Plugins: "Plugins",
  "Handy Shortcuts": "Atajos útiles",
  "Horizontal line": "Línea horizontal",
  "Insert/edit image": "Insertar/editar imagen",
  "Alternative description": "Descripción alternativa",
  Accessibility: "Accesibilidad",
  "Image is decorative": "La imagen es decorativa",
  Source: "Fuente",
  Dimensions: "Dimensiones",
  "Constrain proportions": "Mantener proporciones",
  General: "General",
  Advanced: "Avanzado",
  Style: "Estilo",
  "Vertical space": "Espacio vertical",
  "Horizontal space": "Espacio horizontal",
  Border: "Borde",
  "Insert image": "Insertar imagen",
  "Image...": "Imagen...",
  "Image list": "Lista de imágenes",
  Resize: "Cambiar tamaño",
  "Insert date/time": "Insertar fecha/hora",
  "Date/time": "Fecha/hora",
  "Insert/edit link": "Insertar/editar enlace",
  "Text to display": "Texto a mostrar",
  Url: "URL",
  "Open link in...": "Abrir enlace en...",
  "Current window": "Ventana actual",
  None: "Ninguno",
  "New window": "Nueva ventana",
  "Open link": "Abrir enlace",
  "Remove link": "Quitar enlace",
  Anchors: "Anclas",
  "Link...": "Enlace...",
  "Paste or type a link": "Pegar o escribir un enlace",
  "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?":
    "La URL que has introducido parece ser una dirección de correo electrónico. ¿Quieres añadir el prefijo mailto: necesario?",
  "The URL you entered seems to be an external link. Do you want to add the required http:// prefix?":
    "La URL que has introducido parece ser un enlace externo. ¿Quieres añadir el prefijo http:// necesario?",
  "The URL you entered seems to be an external link. Do you want to add the required https:// prefix?":
    "La URL que has introducido parece ser un enlace externo. ¿Quieres añadir el prefijo https:// necesario?",
  "Link list": "Lista de enlaces",
  "Insert video": "Insertar video",
  "Insert/edit video": "Insertar/editar video",
  "Insert/edit media": "Insertar/editar medio",
  "Alternative source": "Fuente alternativa",
  "Alternative source URL": "URL de la fuente alternativa",
  "Media poster (Image URL)": "Póster de medio (URL de la imagen)",
  "Paste your embed code below:": "Pega tu código de inserción abajo:",
  Embed: "Insertar",
  "Media...": "Medio...",
  "Nonbreaking space": "Espacio de no separación",
  "Page break": "Salto de página",
  "Paste as text": "Pegar como texto",
  Preview: "Previsualizar",
  Print: "Imprimir",
  "Print...": "Imprimir...",
  Save: "Guardar",
  Find: "Buscar",
  "Replace with": "Reemplazar con",
  Replace: "Reemplazar",
  "Replace all": "Reemplazar todo",
  Previous: "Anterior",
  Next: "Siguiente",
  "Find and Replace": "Buscar y reemplazar",
  "Find and replace...": "Buscar y reemplazar...",
  "Could not find the specified string.": "No se pudo encontrar la cadena especificada.",
  "Match case": "Coincidir mayúsculas y minúsculas",
  "Find whole words only": "Solo palabras completas",
  "Find in selection": "Buscar en la selección",
  "Insert table": "Insertar tabla",
  "Table properties": "Propiedades de la tabla",
  "Delete table": "Eliminar tabla",
  Cell: "Celda",
  Row: "Fila",
  Column: "Columna",
  "Cell properties": "Propiedades de la celda",
  "Merge cells": "Combinar celdas",
  "Split cell": "Dividir celda",
  "Insert row before": "Insertar fila antes",
  "Insert row after": "Insertar fila después",
  "Delete row": "Eliminar fila",
  "Row properties": "Propiedades de la fila",
  "Cut row": "Cortar fila",
  "Cut column": "Cortar columna",
  "Copy row": "Copiar fila",
  "Copy column": "Copiar columna",
  "Paste row before": "Pegar fila antes",
  "Paste column before": "Pegar columna antes",
  "Paste row after": "Pegar fila después",
  "Paste column after": "Pegar columna después",
  "Insert column before": "Insertar columna antes",
  "Insert column after": "Insertar columna después",
  "Delete column": "Eliminar columna",
  Cols: "Columnas",
  Rows: "Filas",
  Width: "Ancho",
  Height: "Altura",
  "Cell spacing": "Espaciado de celda",
  "Cell padding": "Relleno de celda",
  "Row clipboard actions": "Acciones del portapapeles de la fila",
  "Column clipboard actions": "Acciones del portapapeles de la columna",
  "Table styles": "Estilos de tabla",
  "Cell styles": "Estilos de celda",
  "Column header": "Encabezado de columna",
  "Row header": "Encabezado de fila",
  "Table caption": "Título de la tabla",
  Caption: "Título",
  "Show caption": "Mostrar título",
  Left: "Izquierda",
  Center: "Centro",
  Right: "Derecha",
  "Cell type": "Tipo de celda",
  Scope: "Alcance",
  Alignment: "Alineación",
  "Horizontal align": "Alineación horizontal",
  "Vertical align": "Alineación vertical",
  Top: "Arriba",
  Middle: "Medio",
  Bottom: "Abajo",
  "Header cell": "Celda de encabezado",
  "Row group": "Grupo de filas",
  "Column group": "Grupo de columnas",
  "Row type": "Tipo de fila",
  Header: "Encabezado",
  Body: "Cuerpo",
  Footer: "Pie de página",
  "Border color": "Color de borde",
  Solid: "Sólido",
  Dotted: "Punteado",
  Dashed: "Discontinuo",
  Double: "Doble",
  Groove: "Con ranura",
  Ridge: "Con cresta",
  Inset: "Incrustado",
  Outset: "Saliente",
  Hidden: "Oculto",
  "Insert template...": "Insertar plantilla...",
  Templates: "Plantillas",
  Template: "Plantilla",
  "Insert Template": "Insertar plantilla",
  "Text color": "Color del texto",
  "Background color": "Color de fondo",
  "Custom...": "Personalizado...",
  "Custom color": "Color personalizado",
  "No color": "Sin color",
  "Remove color": "Eliminar color",
  "Show blocks": "Mostrar bloques",
  "Show invisible characters": "Mostrar caracteres invisibles",
  "Word count": "Contador de palabras",
  Count: "Conteo",
  Document: "Documento",
  Selection: "Selección",
  Words: "Palabras",
  "Words: {0}": "Palabras: {0}",
  "{0} words": "{0} palabras",
  File: "Archivo",
  Edit: "Editar",
  Insert: "Insertar",
  View: "Ver",
  Format: "Formato",
  Table: "Tabla",
  Tools: "Herramientas",
  "Powered by {0}": "Con la tecnología de {0}",
  "Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help":
    "Área de texto enriquecido. Presiona ALT+F9 para el menú. Presiona ALT+F10 para la barra de herramientas. Presiona ALT+0 para ayuda.",
  "Image title": "Título de la imagen",
  "Border width": "Ancho del borde",
  "Border style": "Estilo del borde",
  Error: "Error",
  Warn: "Advertir",
  Valid: "Válido",
  "To open the popup, press Shift+Enter": "Para abrir la ventana emergente, presiona Shift+Enter",
  "Rich Text Area": "Área de texto enriquecido",
  "Rich Text Area. Press ALT-0 for help.": "Área de texto enriquecido. Presiona ALT+0 para ayuda.",
  "System Font": "Fuente del sistema",
  "Failed to upload image: {0}": "Error al subir la imagen: {0}",
  "Failed to load plugin: {0} from url {1}": "Error al cargar el plugin: {0} de la URL {1}",
  "Failed to load plugin url: {0}": "Error al cargar la URL del plugin: {0}",
  "Failed to initialize plugin: {0}": "Error al inicializar el plugin: {0}",
  example: "ejemplo",
  Search: "Buscar",
  All: "Todo",
  Currency: "Moneda",
  Text: "Texto",
  Quotations: "Citas",
  Mathematical: "Operadores matemáticos",
  "Extended Latin": "Latín extendido",
  Symbols: "Símbolos",
  Arrows: "Flechas",
  "User Defined": "Definido por el usuario",
  "dollar sign": "Símbolo de dólar",
  "currency sign": "Símbolo de moneda",
  "euro-currency sign": "Símbolo de euro",
  "colon sign": "Símbolo de colón",
  "cruzeiro sign": "Símbolo de cruzeiro",
  "french franc sign": "Símbolo de franco francés",
  "lira sign": "Símbolo de lira",
  "mill sign": "Símbolo de molino",
  "naira sign": "Símbolo de naira",
  "peseta sign": "Símbolo de peseta",
  "rupee sign": "Símbolo de rupia",
  "won sign": "Símbolo de won",
  "new sheqel sign": "Símbolo de nuevo sheqel",
  "dong sign": "Símbolo de dong",
  "kip sign": "Símbolo de kip",
  "tugrik sign": "Símbolo de tugrik",
  "drachma sign": "Símbolo de dracma",
  "german penny symbol": "Símbolo de pfennig",
  "peso sign": "Símbolo de peso",
  "guarani sign": "Símbolo de guaraní",
  "austral sign": "Símbolo de austral",
  "hryvnia sign": "Símbolo de hryvnia",
  "cedi sign": "Símbolo de cedi",
  "livre tournois sign": "Símbolo de libra tournois",
  "spesmilo sign": "Símbolo de spesmilo",
  "tenge sign": "Símbolo de tenge",
  "indian rupee sign": "Símbolo de rupia india",
  "turkish lira sign": "Símbolo de lira turca",
  "nordic mark sign": "Símbolo de marco nórdico",
  "manat sign": "Símbolo de manat",
  "ruble sign": "Símbolo de rublo",
  "yen character": "Caracter yen",
  "yuan character": "Caracter yuan",
  "yuan character, in hong kong and taiwan": "Caracter yuan, en Hong Kong y Taiwán",
  "yen/yuan character variant one": "Variante uno del caracter yen/yuan",
  Emojis: "Emojis",
  "Emojis...": "Emojis...",
  "Loading emojis...": "Cargando emojis...",
  "Could not load emojis": "No se pudieron cargar los emojis",
  People: "Personas",
  "Animals and Nature": "Animales y naturaleza",
  "Food and Drink": "Comida y bebida",
  Activity: "Actividad",
  "Travel and Places": "Viajes y lugares",
  Objects: "Objetos",
  Flags: "Banderas",
  Characters: "Caracteres",
  "Characters (no spaces)": "Caracteres (sin espacios)",
  "{0} characters": "{0} caracteres",
  "Error: Form submit field collision.": "Error: colisión de campo al enviar el formulario.",
  "Error: No form element found.": "Error: no se encontró ningún elemento de formulario.",
  "Color swatch": "Muestra de color",
  "Color Picker": "Selector de color",
  "Invalid hex color code: {0}": "Código de color hexadecimal no válido: {0}",
  "Invalid input": "Entrada no válida",
  R: "R",
  "Red component": "Componente rojo",
  G: "G",
  "Green component": "Componente verde",
  B: "B",
  "Blue component": "Componente azul",
  "#": "#",
  "Hex color code": "Código de color hexadecimal",
  "Range 0 to 255": "Rango de 0 a 255",
  Turquoise: "Turquesa",
  Green: "Verde",
  Blue: "Azul",
  Purple: "Morado",
  "Navy Blue": "Azul marino",
  "Dark Turquoise": "Turquesa oscuro",
  "Dark Green": "Verde oscuro",
  "Medium Blue": "Azul medio",
  "Medium Purple": "Morado medio",
  "Midnight Blue": "Azul de medianoche",
  Yellow: "Amarillo",
  Orange: "Naranja",
  Red: "Rojo",
  "Light Gray": "Gris claro",
  Gray: "Gris",
  "Dark Yellow": "Amarillo oscuro",
  "Dark Orange": "Naranja oscuro",
  "Dark Red": "Rojo oscuro",
  "Medium Gray": "Gris medio",
  "Dark Gray": "Gris oscuro",
  "Light Green": "Verde claro",
  "Light Yellow": "Amarillo claro",
  "Light Red": "Rojo claro",
  "Light Purple": "Morado claro",
  "Light Blue": "Azul claro",
  "Dark Purple": "Morado oscuro",
  "Dark Blue": "Azul oscuro",
  Black: "Negro",
  White: "Blanco",
  "Switch to or from fullscreen mode": "Cambiar a o desde el modo de pantalla completa",
  "Open help dialog": "Abrir el diálogo de ayuda",
  history: "historial",
  styles: "estilos",
  formatting: "formato",
  alignment: "alineación",
  indentation: "sangría",
  Font: "Fuente",
  Size: "Tamaño",
  "More...": "Más...",
  "Select...": "Seleccionar...",
  Preferences: "Preferencias",
  Yes: "Sí",
  No: "No",
  "Keyboard Navigation": "Navegación con teclado",
  Version: "Versión",
  "Code view": "Vista de código",
  "Open popup menu for split buttons": "Abrir menú emergente para botones divididos",
  "List Properties": "Propiedades de la lista",
  "List properties...": "Propiedades de la lista...",
  "Start list at number": "Comenzar lista en el número",
  "Line height": "Altura de línea",
  "Dropped file type is not supported": "El tipo de archivo arrastrado no es compatible",
  "Loading...": "Cargando...",
  "ImageProxy HTTP error: Rejected request": "Error HTTP de ImageProxy: Solicitud rechazada",
  "ImageProxy HTTP error: Could not find Image Proxy":
    "Error HTTP de ImageProxy: No se pudo encontrar Image Proxy",
  "ImageProxy HTTP error: Incorrect Image Proxy URL":
    "Error HTTP de ImageProxy: URL de Image Proxy incorrecta",
  "ImageProxy HTTP error: Unknown ImageProxy error":
    "Error HTTP de ImageProxy: Error de ImageProxy desconocido",
});

addI18n("fr", {
  Redo: "R\xe9tablir",
  Undo: "Annuler",
  Cut: "Couper",
  Copy: "Copier",
  Paste: "Coller",
  "Select all": "S\xe9lectionner tout",
  "New document": "Nouveau document",
  Ok: "OK",
  Cancel: "Annuler",
  "Visual aids": "Aides visuelles",
  Bold: "Gras",
  Italic: "Italique",
  Underline: "Soulign\xe9",
  Strikethrough: "Barr\xe9",
  Superscript: "Exposant",
  Subscript: "Indice",
  "Clear formatting": "Effacer la mise en forme",
  Remove: "Retir\xe9",
  "Align left": "Aligner \xe0 gauche",
  "Align center": "Centrer",
  "Align right": "Aligner \xe0 droite",
  "No alignment": "Aucun alignement",
  Justify: "Justifier",
  "Bullet list": "Liste \xe0 puces",
  "Numbered list": "Liste num\xe9rot\xe9e",
  "Decrease indent": "R\xe9duire le retrait",
  "Increase indent": "Augmenter le retrait",
  Close: "Fermer",
  Formats: "Formats",
  "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.":
    "Votre navigateur ne supporte pas l\u2019acc\xe8s direct au presse-papiers. Merci d'utiliser les raccourcis clavier Ctrl+X/C/V.",
  Headings: "Titres",
  "Heading 1": "Titre\xa01",
  "Heading 2": "Titre\xa02",
  "Heading 3": "Titre\xa03",
  "Heading 4": "Titre\xa04",
  "Heading 5": "Titre\xa05",
  "Heading 6": "Titre\xa06",
  Preformatted: "Pr\xe9format\xe9",
  Div: "Div",
  Pre: "Pr\xe9format\xe9",
  Code: "Code",
  Paragraph: "Paragraphe",
  Blockquote: "Bloc de citation",
  Inline: "En ligne",
  Blocks: "Blocs",
  "Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.":
    "Le collage est maintenant en mode texte brut. Les contenus seront coll\xe9s sans retenir les formatages jusqu'\xe0 ce que vous d\xe9sactivez cette option.",
  Fonts: "Polices",
  "Font sizes": "Tailles de police",
  Class: "Classe",
  "Browse for an image": "Rechercher une image",
  OR: "OU",
  "Drop an image here": "D\xe9poser une image ici",
  Upload: "T\xe9l\xe9charger",
  "Uploading image": "T\xe9l\xe9versement d'une image",
  Block: "Bloc",
  Align: "Aligner",
  Default: "Par d\xe9faut",
  Circle: "Cercle",
  Disc: "Disque",
  Square: "Carr\xe9",
  "Lower Alpha": "Alphabet en minuscules",
  "Lower Greek": "Alphabet grec en minuscules",
  "Lower Roman": "Chiffre romain inf\xe9rieur",
  "Upper Alpha": "Alphabet en majuscules",
  "Upper Roman": "Chiffre romain sup\xe9rieur",
  "Anchor...": "Ancre...",
  Anchor: "Ancre",
  Name: "Nom",
  ID: "ID",
  "ID should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.":
    "L'ID doit commencer par une lettre, suivie uniquement par des lettres, num\xe9ros, tirets, points, deux-points et underscores.",
  "You have unsaved changes are you sure you want to navigate away?":
    "Vous avez des modifications non enregistr\xe9es, \xeates-vous s\xfbr de vouloir quitter la page\xa0?",
  "Restore last draft": "Restaurer le dernier brouillon",
  "Special character...": "Caract\xe8re sp\xe9cial...",
  "Special Character": "Caract\xe8re sp\xe9cial",
  "Source code": "Code source",
  "Insert/Edit code sample": "Ins\xe9rer / modifier un bloc de code",
  Language: "Langue",
  "Code sample...": "Exemple de code...",
  "Left to right": "De gauche \xe0 droite",
  "Right to left": "De droite \xe0 gauche",
  Title: "Titre",
  Fullscreen: "Plein \xe9cran",
  Action: "Action",
  Shortcut: "Raccourci",
  Help: "Aide",
  Address: "Adresse",
  "Focus to menubar": "Mettre le focus sur la barre de menu",
  "Focus to toolbar": "Mettre le focus sur la barre d'outils",
  "Focus to element path": "Mettre le focus sur le chemin vers l'\xe9l\xe9ment",
  "Focus to contextual toolbar": "Mettre le focus sur la barre d'outils contextuelle",
  "Insert link (if link plugin activated)": "Ins\xe9rer un lien (si le plug-in link est activ\xe9)",
  "Save (if save plugin activated)": "Enregistrer (si le plug-in save est activ\xe9)",
  "Find (if searchreplace plugin activated)":
    "Rechercher (si le plug-in searchreplace est activ\xe9)",
  "Plugins installed ({0}):": "Plug-ins install\xe9s ({0})\xa0:",
  "Premium plugins:": "Plug-ins premium\xa0:",
  "Learn more...": "En savoir plus...",
  "You are using {0}": "Vous utilisez {0}",
  Plugins: "Plug-ins",
  "Handy Shortcuts": "Raccourcis utiles",
  "Horizontal line": "Ligne horizontale",
  "Insert/edit image": "Ins\xe9rer/modifier image",
  "Alternative description": "Description alternative",
  Accessibility: "Accessibilit\xe9",
  "Image is decorative": "L'image est d\xe9corative",
  Source: "Source",
  Dimensions: "Dimensions",
  "Constrain proportions": "Limiter les proportions",
  General: "G\xe9n\xe9ral",
  Advanced: "Options avanc\xe9es",
  Style: "Style",
  "Vertical space": "Espace vertical",
  "Horizontal space": "Espace horizontal",
  Border: "Bordure",
  "Insert image": "Ins\xe9rer une image",
  "Image...": "Image...",
  "Image list": "Liste des images",
  Resize: "Redimensionner",
  "Insert date/time": "Ins\xe9rer date/heure",
  "Date/time": "Date/heure",
  "Insert/edit link": "Ins\xe9rer/modifier lien",
  "Text to display": "Texte \xe0 afficher",
  Url: "URL",
  "Open link in...": "Ouvrir le lien dans...",
  "Current window": "Fen\xeatre active",
  None: "Aucun",
  "New window": "Nouvelle fen\xeatre",
  "Open link": "Ouvrir le lien",
  "Remove link": "Enlever le lien",
  Anchors: "Ancres",
  "Link...": "Lien...",
  "Paste or type a link": "Coller ou taper un lien",
  "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?":
    "L'URL que vous avez saisi semble \xeatre une adresse e-mail. Souhaitez-vous y ajouter le pr\xe9fixe requis mailto:\xa0?",
  "The URL you entered seems to be an external link. Do you want to add the required http:// prefix?":
    "L'URL que vous avez saisi semble \xeatre un lien externe. Souhaitez-vous y ajouter le pr\xe9fixe requis mailto:\xa0?",
  "The URL you entered seems to be an external link. Do you want to add the required https:// prefix?":
    "L'URL que vous avez saisie semble \xeatre un lien externe. Voulez-vous ajouter le pr\xe9fixe https:// requis\xa0?",
  "Link list": "Liste des liens",
  "Insert video": "Ins\xe9rer une vid\xe9o",
  "Insert/edit video": "Ins\xe9rer/modifier une vid\xe9o",
  "Insert/edit media": "Ins\xe9rer/modifier un m\xe9dia",
  "Alternative source": "Source alternative",
  "Alternative source URL": "URL de la source alternative",
  "Media poster (Image URL)": "Affiche de m\xe9dia (URL de l'image)",
  "Paste your embed code below:": "Collez votre code incorpor\xe9 ci-dessous :",
  Embed: "Incorporer",
  "Media...": "M\xe9dia...",
  "Nonbreaking space": "Espace ins\xe9cable",
  "Page break": "Saut de page",
  "Paste as text": "Coller comme texte",
  Preview: "Aper\xe7u",
  Print: "Imprimer",
  "Print...": "Imprimer...",
  Save: "Enregistrer",
  Find: "Rechercher",
  "Replace with": "Remplacer par",
  Replace: "Remplacer",
  "Replace all": "Remplacer tout",
  Previous: "Pr\xe9c\xe9dente",
  Next: "Suivante",
  "Find and Replace": "Trouver et remplacer",
  "Find and replace...": "Trouver et remplacer...",
  "Could not find the specified string.": "Impossible de trouver la cha\xeene sp\xe9cifi\xe9e.",
  "Match case": "Respecter la casse",
  "Find whole words only": "Mot entier",
  "Find in selection": "Trouver dans la s\xe9lection",
  "Insert table": "Ins\xe9rer un tableau",
  "Table properties": "Propri\xe9t\xe9s du tableau",
  "Delete table": "Supprimer le tableau",
  Cell: "Cellule",
  Row: "Ligne",
  Column: "Colonne",
  "Cell properties": "Propri\xe9t\xe9s de la cellule",
  "Merge cells": "Fusionner les cellules",
  "Split cell": "Diviser la cellule",
  "Insert row before": "Ins\xe9rer une ligne avant",
  "Insert row after": "Ins\xe9rer une ligne apr\xe8s",
  "Delete row": "Supprimer la ligne",
  "Row properties": "Propri\xe9t\xe9s de la ligne",
  "Cut row": "Couper la ligne",
  "Cut column": "Couper la colonne",
  "Copy row": "Copier la ligne",
  "Copy column": "Copier la colonne",
  "Paste row before": "Coller la ligne avant",
  "Paste column before": "Coller la colonne avant",
  "Paste row after": "Coller la ligne apr\xe8s",
  "Paste column after": "Coller la colonne apr\xe8s",
  "Insert column before": "Ins\xe9rer une colonne avant",
  "Insert column after": "Ins\xe9rer une colonne apr\xe8s",
  "Delete column": "Supprimer la colonne",
  Cols: "Colonnes",
  Rows: "Lignes",
  Width: "Largeur",
  Height: "Hauteur",
  "Cell spacing": "Espacement entre les cellules",
  "Cell padding": "Marge int\xe9rieure des cellules",
  "Row clipboard actions": "Actions du presse-papiers des lignes",
  "Column clipboard actions": "Actions du presse-papiers des colonnes",
  "Table styles": "Style tableau",
  "Cell styles": "Type de cellule",
  "Column header": "En-t\xeate de colonne",
  "Row header": "En-t\xeate de ligne",
  "Table caption": "L\xe9gende de tableau",
  Caption: "L\xe9gende",
  "Show caption": "Afficher une l\xe9gende",
  Left: "Gauche",
  Center: "Centre",
  Right: "Droite",
  "Cell type": "Type de cellule",
  Scope: "\xc9tendue",
  Alignment: "Alignement",
  "Horizontal align": "Alignement horizontal",
  "Vertical align": "Alignement vertical",
  Top: "En haut",
  Middle: "Au milieu",
  Bottom: "En bas",
  "Header cell": "Cellule d'en-t\xeate",
  "Row group": "Groupe de lignes",
  "Column group": "Groupe de colonnes",
  "Row type": "Type de ligne",
  Header: "En-t\xeate",
  Body: "Corps",
  Footer: "Pied de page",
  "Border color": "Couleur de bordure",
  Solid: "Trait continu",
  Dotted: "Pointill\xe9",
  Dashed: "Tirets",
  Double: "Deux traits continus",
  Groove: "Sculpt\xe9",
  Ridge: "Extrud\xe9",
  Inset: "Incrust\xe9",
  Outset: "Relief",
  Hidden: "Masqu\xe9",
  "Insert template...": "Ins\xe9rer un mod\xe8le...",
  Templates: "Mod\xe8les",
  Template: "Mod\xe8le",
  "Insert Template": "Ins\xe9rer le mod\xe8le",
  "Text color": "Couleur du texte",
  "Background color": "Couleur d'arri\xe8re-plan",
  "Custom...": "Personnalis\xe9e...",
  "Custom color": "Couleur personnalis\xe9e",
  "No color": "Aucune couleur",
  "Remove color": "Supprimer la couleur",
  "Show blocks": "Afficher les blocs",
  "Show invisible characters": "Afficher les caract\xe8res invisibles",
  "Word count": "Nombre de mots",
  Count: "Total",
  Document: "Document",
  Selection: "S\xe9lection",
  Words: "Mots",
  "Words: {0}": "Mots\xa0: {0}",
  "{0} words": "{0} mots",
  File: "Fichier",
  Edit: "Modifier",
  Insert: "Ins\xe9rer",
  View: "Afficher",
  Format: "Format",
  Table: "Tableau",
  Tools: "Outils",
  "Powered by {0}": "Avec {0}",
  "Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help":
    "Zone de Texte Riche. Appuyez sur ALT-F9 pour le menu. Appuyez sur ALT-F10 pour la barre d'outils. Appuyez sur ALT-0 pour l'aide",
  "Image title": "Titre d'image",
  "Border width": "\xc9paisseur de la bordure",
  "Border style": "Style de la bordure",
  Error: "Erreur",
  Warn: "Avertir",
  Valid: "Valide",
  "To open the popup, press Shift+Enter": "Pour ouvrir la popup, appuyez sur Maj+Entr\xe9e",
  "Rich Text Area": "Zone de Texte Riche",
  "Rich Text Area. Press ALT-0 for help.": "Zone de Texte Riche. Appuyez sur ALT-0 pour l'aide.",
  "System Font": "Police syst\xe8me",
  "Failed to upload image: {0}": "\xc9chec d'envoi de l'image\xa0: {0}",
  "Failed to load plugin: {0} from url {1}":
    "\xc9chec de chargement du plug-in\xa0: {0} \xe0 partir de l\u2019URL {1}",
  "Failed to load plugin url: {0}": "\xc9chec de chargement de l'URL du plug-in\xa0: {0}",
  "Failed to initialize plugin: {0}": "\xc9chec d'initialisation du plug-in\xa0: {0}",
  example: "exemple",
  Search: "Rechercher",
  All: "Tout",
  Currency: "Devise",
  Text: "Texte",
  Quotations: "Citations",
  Mathematical: "Op\xe9rateurs math\xe9matiques",
  "Extended Latin": "Latin \xe9tendu",
  Symbols: "Symboles",
  Arrows: "Fl\xe8ches",
  "User Defined": "D\xe9fini par l'utilisateur",
  "dollar sign": "Symbole dollar",
  "currency sign": "Symbole devise",
  "euro-currency sign": "Symbole euro",
  "colon sign": "Symbole col\xf3n",
  "cruzeiro sign": "Symbole cruzeiro",
  "french franc sign": "Symbole franc fran\xe7ais",
  "lira sign": "Symbole lire",
  "mill sign": "Symbole milli\xe8me",
  "naira sign": "Symbole naira",
  "peseta sign": "Symbole peseta",
  "rupee sign": "Symbole roupie",
  "won sign": "Symbole won",
  "new sheqel sign": "Symbole nouveau ch\xe9kel",
  "dong sign": "Symbole dong",
  "kip sign": "Symbole kip",
  "tugrik sign": "Symbole tougrik",
  "drachma sign": "Symbole drachme",
  "german penny symbol": "Symbole pfennig",
  "peso sign": "Symbole peso",
  "guarani sign": "Symbole guarani",
  "austral sign": "Symbole austral",
  "hryvnia sign": "Symbole hryvnia",
  "cedi sign": "Symbole cedi",
  "livre tournois sign": "Symbole livre tournois",
  "spesmilo sign": "Symbole spesmilo",
  "tenge sign": "Symbole tenge",
  "indian rupee sign": "Symbole roupie indienne",
  "turkish lira sign": "Symbole lire turque",
  "nordic mark sign": "Symbole du mark nordique",
  "manat sign": "Symbole manat",
  "ruble sign": "Symbole rouble",
  "yen character": "Sinogramme Yen",
  "yuan character": "Sinogramme Yuan",
  "yuan character, in hong kong and taiwan": "Sinogramme Yuan, Hong Kong et Taiwan",
  "yen/yuan character variant one": "Sinogramme Yen/Yuan, premi\xe8re variante",
  Emojis: "\xc9mojis",
  "Emojis...": "\xc9mojis...",
  "Loading emojis...": "Chargement des emojis...",
  "Could not load emojis": "Impossible de charger les emojis",
  People: "Personnes",
  "Animals and Nature": "Animaux & nature",
  "Food and Drink": "Nourriture & boissons",
  Activity: "Activit\xe9",
  "Travel and Places": "Voyages & lieux",
  Objects: "Objets",
  Flags: "Drapeaux",
  Characters: "Caract\xe8res",
  "Characters (no spaces)": "Caract\xe8res (espaces non compris)",
  "{0} characters": "{0}\xa0caract\xe8res",
  "Error: Form submit field collision.":
    "Erreur\xa0: conflit de champs lors de la soumission du formulaire.",
  "Error: No form element found.": "Erreur : aucun \xe9l\xe9ment de formulaire trouv\xe9.",
  "Color swatch": "\xc9chantillon de couleurs",
  "Color Picker": "S\xe9lecteur de couleurs",
  "Invalid hex color code: {0}": "Code couleur hexad\xe9cimal invalide : {0}",
  "Invalid input": "Entr\xe9e invalide",
  R: "R",
  "Red component": "Composant rouge",
  G: "V",
  "Green component": "Composant vert",
  B: "B",
  "Blue component": "Composant bleu",
  "#": "#",
  "Hex color code": "Code couleur hexad\xe9cimal",
  "Range 0 to 255": "Plage de 0 \xe0 255",
  Turquoise: "Turquoise",
  Green: "Vert",
  Blue: "Bleu",
  Purple: "Violet",
  "Navy Blue": "Bleu marine",
  "Dark Turquoise": "Turquoise fonc\xe9",
  "Dark Green": "Vert fonc\xe9",
  "Medium Blue": "Bleu moyen",
  "Medium Purple": "Violet moyen",
  "Midnight Blue": "Bleu de minuit",
  Yellow: "Jaune",
  Orange: "Orange",
  Red: "Rouge",
  "Light Gray": "Gris clair",
  Gray: "Gris",
  "Dark Yellow": "Jaune fonc\xe9",
  "Dark Orange": "Orange fonc\xe9",
  "Dark Red": "Rouge fonc\xe9",
  "Medium Gray": "Gris moyen",
  "Dark Gray": "Gris fonc\xe9",
  "Light Green": "Vert clair",
  "Light Yellow": "Jaune clair",
  "Light Red": "Rouge clair",
  "Light Purple": "Violet clair",
  "Light Blue": "Bleu clair",
  "Dark Purple": "Violet fonc\xe9",
  "Dark Blue": "Bleu fonc\xe9",
  Black: "Noir",
  White: "Blanc",
  "Switch to or from fullscreen mode": "Passer en ou quitter le mode plein \xe9cran",
  "Open help dialog": "Ouvrir la bo\xeete de dialogue d'aide",
  history: "historique",
  styles: "styles",
  formatting: "mise en forme",
  alignment: "alignement",
  indentation: "retrait",
  Font: "Police",
  Size: "Taille",
  "More...": "Plus...",
  "Select...": "S\xe9lectionner...",
  Preferences: "Pr\xe9f\xe9rences",
  Yes: "Oui",
  No: "Non",
  "Keyboard Navigation": "Navigation au clavier",
  Version: "Version",
  "Code view": "Affichage du code",
  "Open popup menu for split buttons": "Ouvrir le menu contextuel pour les boutons partag\xe9s",
  "List Properties": "Propri\xe9t\xe9s de la liste",
  "List properties...": "Lister les propri\xe9t\xe9s...",
  "Start list at number": "Liste de d\xe9part au num\xe9ro",
  "Line height": "Hauteur de la ligne",
  "Dropped file type is not supported": "Le type de fichier d\xe9pos\xe9 n'est pas pris en charge",
  "Loading...": "Chargement...",
  "ImageProxy HTTP error: Rejected request": "Erreur HTTP d'ImageProxy : Requ\xeate rejet\xe9e",
  "ImageProxy HTTP error: Could not find Image Proxy":
    "Erreur HTTP d'ImageProxy : Impossible de trouver ImageProxy",
  "ImageProxy HTTP error: Incorrect Image Proxy URL":
    "Erreur HTTP d'ImageProxy : URL de ImageProxy incorrecte",
  "ImageProxy HTTP error: Unknown ImageProxy error":
    "Erreur HTTP d'ImageProxy : Erreur ImageProxy inconnue",
});

addI18n("it", {
  Redo: "Ripristina",
  Undo: "Annulla",
  Cut: "Taglia",
  Copy: "Copia",
  Paste: "Incolla",
  "Select all": "Seleziona tutto",
  "New document": "Nuovo documento",
  Ok: "OK",
  Cancel: "Annulla",
  "Visual aids": "Aiuti visivi",
  Bold: "Grassetto",
  Italic: "Corsivo",
  Underline: "Sottolineato",
  Strikethrough: "Barrato",
  Superscript: "Apice",
  Subscript: "Pedice",
  "Clear formatting": "Cancella formattazione",
  Remove: "Rimuovi",
  "Align left": "Allinea a sinistra",
  "Align center": "Centra",
  "Align right": "Allinea a destra",
  "No alignment": "Nessun allineamento",
  Justify: "Giustifica",
  "Bullet list": "Elenco puntato",
  "Numbered list": "Elenco numerato",
  "Decrease indent": "Riduci rientro",
  "Increase indent": "Aumenta rientro",
  Close: "Chiudi",
  Formats: "Formati",
  "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.":
    "Il tuo browser non supporta l'accesso diretto agli appunti. Per favore usa le scorciatoie da tastiera Ctrl+X/C/V.",
  Headings: "Intestazioni",
  "Heading 1": "Titolo 1",
  "Heading 2": "Titolo 2",
  "Heading 3": "Titolo 3",
  "Heading 4": "Titolo 4",
  "Heading 5": "Titolo 5",
  "Heading 6": "Titolo 6",
  Preformatted: "Preformattato",
  Div: "Div",
  Pre: "Pre",
  Code: "Codice",
  Paragraph: "Paragrafo",
  Blockquote: "Citazione",
  Inline: "In linea",
  Blocks: "Blocchi",
  "Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.":
    "L'incolla è ora in modalità testo semplice. I contenuti verranno incollati come testo semplice finché non disattivi questa opzione.",
  Fonts: "Caratteri",
  "Font sizes": "Dimensioni carattere",
  Class: "Classe",
  "Browse for an image": "Cerca un'immagine",
  OR: "O",
  "Drop an image here": "Trascina un'immagine qui",
  Upload: "Carica",
  "Uploading image": "Caricamento immagine",
  Block: "Blocco",
  Align: "Allinea",
  Default: "Predefinito",
  Circle: "Cerchio",
  Disc: "Disco",
  Square: "Quadrato",
  "Lower Alpha": "Alfabetico minuscolo",
  "Lower Greek": "Greco minuscolo",
  "Lower Roman": "Romano minuscolo",
  "Upper Alpha": "Alfabetico maiuscolo",
  "Upper Roman": "Romano maiuscolo",
  "Anchor...": "Ancora...",
  Anchor: "Ancora",
  Name: "Nome",
  ID: "ID",
  "ID should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.":
    "L'ID dovrebbe iniziare con una lettera, seguita solo da lettere, numeri, trattini, punti, due punti o trattini bassi.",
  "You have unsaved changes are you sure you want to navigate away?":
    "Hai modifiche non salvate, sei sicuro di voler abbandonare la pagina?",
  "Restore last draft": "Ripristina l'ultima bozza",
  "Special character...": "Carattere speciale...",
  "Special Character": "Carattere speciale",
  "Source code": "Codice sorgente",
  "Insert/Edit code sample": "Inserisci/Modifica esempio di codice",
  Language: "Lingua",
  "Code sample...": "Esempio di codice...",
  "Left to right": "Da sinistra a destra",
  "Right to left": "Da destra a sinistra",
  Title: "Titolo",
  Fullscreen: "Schermo intero",
  Action: "Azione",
  Shortcut: "Scorciatoia",
  Help: "Aiuto",
  Address: "Indirizzo",
  "Focus to menubar": "Focus sulla barra dei menu",
  "Focus to toolbar": "Focus sulla barra degli strumenti",
  "Focus to element path": "Focus sul percorso dell'elemento",
  "Focus to contextual toolbar": "Focus sulla barra degli strumenti contestuale",
  "Insert link (if link plugin activated)": "Inserisci link (se il plugin link è attivato)",
  "Save (if save plugin activated)": "Salva (se il plugin save è attivato)",
  "Find (if searchreplace plugin activated)": "Trova (se il plugin searchreplace è attivato)",
  "Plugins installed ({0}):": "Plugin installati ({0}):",
  "Premium plugins:": "Plugin Premium:",
  "Learn more...": "Saperne di più...",
  "You are using {0}": "Stai usando {0}",
  Plugins: "Plugin",
  "Handy Shortcuts": "Scorciatoie utili",
  "Horizontal line": "Linea orizzontale",
  "Insert/edit image": "Inserisci/modifica immagine",
  "Alternative description": "Descrizione alternativa",
  Accessibility: "Accessibilità",
  "Image is decorative": "L'immagine è decorativa",
  Source: "Fonte",
  Dimensions: "Dimensioni",
  "Constrain proportions": "Mantieni proporzioni",
  General: "Generale",
  Advanced: "Avanzate",
  Style: "Stile",
  "Vertical space": "Spaziatura verticale",
  "Horizontal space": "Spaziatura orizzontale",
  Border: "Bordo",
  "Insert image": "Inserisci immagine",
  "Image...": "Immagine...",
  "Image list": "Elenco immagini",
  Resize: "Ridimensiona",
  "Insert date/time": "Inserisci data/ora",
  "Date/time": "Data/ora",
  "Insert/edit link": "Inserisci/modifica link",
  "Text to display": "Testo da visualizzare",
  Url: "URL",
  "Open link in...": "Apri link in...",
  "Current window": "Finestra corrente",
  None: "Nessuno",
  "New window": "Nuova finestra",
  "Open link": "Apri link",
  "Remove link": "Rimuovi link",
  Anchors: "Ancore",
  "Link...": "Link...",
  "Paste or type a link": "Incolla o scrivi un link",
  "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?":
    "L'URL inserito sembra essere un indirizzo email. Vuoi aggiungere il prefisso mailto: necessario?",
  "The URL you entered seems to be an external link. Do you want to add the required http:// prefix?":
    "L'URL inserito sembra essere un link esterno. Vuoi aggiungere il prefisso http:// necessario?",
  "The URL you entered seems to be an external link. Do you want to add the required https:// prefix?":
    "L'URL inserito sembra essere un link esterno. Vuoi aggiungere il prefisso https:// necessario?",
  "Link list": "Elenco link",
  "Insert video": "Inserisci video",
  "Insert/edit video": "Inserisci/modifica video",
  "Insert/edit media": "Inserisci/modifica media",
  "Alternative source": "Fonte alternativa",
  "Alternative source URL": "URL fonte alternativa",
  "Media poster (Image URL)": "Poster media (URL immagine)",
  "Paste your embed code below:": "Incolla il tuo codice di incorporamento qui sotto:",
  Embed: "Incorpora",
  "Media...": "Media...",
  "Nonbreaking space": "Spazio non divisibile",
  "Page break": "Interruzione di pagina",
  "Paste as text": "Incolla come testo",
  Preview: "Anteprima",
  Print: "Stampa",
  "Print...": "Stampa...",
  Save: "Salva",
  Find: "Trova",
  "Replace with": "Sostituisci con",
  Replace: "Sostituisci",
  "Replace all": "Sostituisci tutto",
  Previous: "Precedente",
  Next: "Successivo",
  "Find and Replace": "Trova e Sostituisci",
  "Find and replace...": "Trova e sostituisci...",
  "Could not find the specified string.": "Impossibile trovare la stringa specificata.",
  "Match case": "Maiuscole/minuscole",
  "Find whole words only": "Solo parole intere",
  "Find in selection": "Trova nella selezione",
  "Insert table": "Inserisci tabella",
  "Table properties": "Proprietà tabella",
  "Delete table": "Elimina tabella",
  Cell: "Cella",
  Row: "Riga",
  Column: "Colonna",
  "Cell properties": "Proprietà cella",
  "Merge cells": "Unisci celle",
  "Split cell": "Dividi cella",
  "Insert row before": "Inserisci riga prima",
  "Insert row after": "Inserisci riga dopo",
  "Delete row": "Elimina riga",
  "Row properties": "Proprietà riga",
  "Cut row": "Taglia riga",
  "Cut column": "Taglia colonna",
  "Copy row": "Copia riga",
  "Copy column": "Copia colonna",
  "Paste row before": "Incolla riga prima",
  "Paste column before": "Incolla colonna prima",
  "Paste row after": "Incolla riga dopo",
  "Paste column after": "Incolla colonna dopo",
  "Insert column before": "Inserisci colonna prima",
  "Insert column after": "Inserisci colonna dopo",
  "Delete column": "Elimina colonna",
  Cols: "Colonne",
  Rows: "Righe",
  Width: "Larghezza",
  Height: "Altezza",
  "Cell spacing": "Spaziatura celle",
  "Cell padding": "Padding celle",
  "Row clipboard actions": "Azioni appunti riga",
  "Column clipboard actions": "Azioni appunti colonna",
  "Table styles": "Stili tabella",
  "Cell styles": "Stili cella",
  "Column header": "Intestazione colonna",
  "Row header": "Intestazione riga",
  "Table caption": "Didascalia tabella",
  Caption: "Didascalia",
  "Show caption": "Mostra didascalia",
  Left: "Sinistra",
  Center: "Centro",
  Right: "Destra",
  "Cell type": "Tipo di cella",
  Scope: "Ambito",
  Alignment: "Allineamento",
  "Horizontal align": "Allineamento orizzontale",
  "Vertical align": "Allineamento verticale",
  Top: "In alto",
  Middle: "In mezzo",
  Bottom: "In basso",
  "Header cell": "Cella intestazione",
  "Row group": "Gruppo righe",
  "Column group": "Gruppo colonne",
  "Row type": "Tipo di riga",
  Header: "Intestazione",
  Body: "Corpo",
  Footer: "Piè di pagina",
  "Border color": "Colore bordo",
  Solid: "Continuo",
  Dotted: "Puntinato",
  Dashed: "Tratteggiato",
  Double: "Doppio",
  Groove: "Incassato",
  Ridge: "In rilievo",
  Inset: "Interno",
  Outset: "Esterno",
  Hidden: "Nascosto",
  "Insert template...": "Inserisci modello...",
  Templates: "Modelli",
  Template: "Modello",
  "Insert Template": "Inserisci Modello",
  "Text color": "Colore testo",
  "Background color": "Colore sfondo",
  "Custom...": "Personalizzato...",
  "Custom color": "Colore personalizzato",
  "No color": "Nessun colore",
  "Remove color": "Rimuovi colore",
  "Show blocks": "Mostra blocchi",
  "Show invisible characters": "Mostra caratteri invisibili",
  "Word count": "Conteggio parole",
  Count: "Conteggio",
  Document: "Documento",
  Selection: "Selezione",
  Words: "Parole",
  "Words: {0}": "Parole: {0}",
  "{0} words": "{0} parole",
  File: "File",
  Edit: "Modifica",
  Insert: "Inserisci",
  View: "Visualizza",
  Format: "Formato",
  Table: "Tabella",
  Tools: "Strumenti",
  "Powered by {0}": "Realizzato con {0}",
  "Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help":
    "Area Rich Text. Premi ALT-F9 per il menu. Premi ALT-F10 per la barra degli strumenti. Premi ALT-0 per l'aiuto",
  "Image title": "Titolo immagine",
  "Border width": "Larghezza bordo",
  "Border style": "Stile bordo",
  Error: "Errore",
  Warn: "Avviso",
  Valid: "Valido",
  "To open the popup, press Shift+Enter": "Per aprire il popup, premi Shift+Invio",
  "Rich Text Area": "Area Rich Text",
  "Rich Text Area. Press ALT-0 for help.": "Area Rich Text. Premi ALT-0 per l'aiuto.",
  "System Font": "Font di sistema",
  "Failed to upload image: {0}": "Impossibile caricare l'immagine: {0}",
  "Failed to load plugin: {0} from url {1}": "Impossibile caricare il plugin: {0} dall'url {1}",
  "Failed to load plugin url: {0}": "Impossibile caricare l'url del plugin: {0}",
  "Failed to initialize plugin: {0}": "Impossibile inizializzare il plugin: {0}",
  example: "esempio",
  Search: "Cerca",
  All: "Tutto",
  Currency: "Valuta",
  Text: "Testo",
  Quotations: "Citazioni",
  Mathematical: "Matematici",
  "Extended Latin": "Latino esteso",
  Symbols: "Simboli",
  Arrows: "Frecce",
  "User Defined": "Definito dall'utente",
  "dollar sign": "simbolo del dollaro",
  "currency sign": "simbolo di valuta",
  "euro-currency sign": "simbolo dell'euro",
  "colon sign": "simbolo del colón",
  "cruzeiro sign": "simbolo del cruzeiro",
  "french franc sign": "simbolo del franco francese",
  "lira sign": "simbolo della lira",
  "mill sign": "simbolo del mill",
  "naira sign": "simbolo della naira",
  "peseta sign": "simbolo della peseta",
  "rupee sign": "simbolo della rupia",
  "won sign": "simbolo del won",
  "new sheqel sign": "simbolo del nuovo sheqel",
  "dong sign": "simbolo del dong",
  "kip sign": "simbolo del kip",
  "tugrik sign": "simbolo del tugrik",
  "drachma sign": "simbolo della dracma",
  "german penny symbol": "simbolo del pfennig tedesco",
  "peso sign": "simbolo del peso",
  "guarani sign": "simbolo del guaraní",
  "austral sign": "simbolo dell'austral",
  "hryvnia sign": "simbolo della grivnia",
  "cedi sign": "simbolo del cedi",
  "livre tournois sign": "simbolo della lira di Tours",
  "spesmilo sign": "simbolo dello spesmilo",
  "tenge sign": "simbolo del tenge",
  "indian rupee sign": "simbolo della rupia indiana",
  "turkish lira sign": "simbolo della lira turca",
  "nordic mark sign": "simbolo del marco nordico",
  "manat sign": "simbolo del manat",
  "ruble sign": "simbolo del rublo",
  "yen character": "carattere yen",
  "yuan character": "carattere yuan",
  "yuan character, in hong kong and taiwan": "carattere yuan, a Hong Kong e Taiwan",
  "yen/yuan character variant one": "variante uno carattere yen/yuan",
  Emojis: "Emoji",
  "Emojis...": "Emoji...",
  "Loading emojis...": "Caricamento emoji...",
  "Could not load emojis": "Impossibile caricare emoji",
  People: "Persone",
  "Animals and Nature": "Animali e Natura",
  "Food and Drink": "Cibo e Bevande",
  Activity: "Attività",
  "Travel and Places": "Viaggi e Luoghi",
  Objects: "Oggetti",
  Flags: "Bandiere",
  Characters: "Caratteri",
  "Characters (no spaces)": "Caratteri (senza spazi)",
  "{0} characters": "{0} caratteri",
  "Error: Form submit field collision.": "Errore: Collisione campo invio modulo.",
  "Error: No form element found.": "Errore: Nessun elemento modulo trovato.",
  "Color swatch": "Campione colore",
  "Color Picker": "Selettore colori",
  "Invalid hex color code: {0}": "Codice colore esadecimale non valido: {0}",
  "Invalid input": "Input non valido",
  R: "R",
  "Red component": "Componente rosso",
  G: "V",
  "Green component": "Componente verde",
  B: "B",
  "Blue component": "Componente blu",
  "#": "#",
  "Hex color code": "Codice colore esadecimale",
  "Range 0 to 255": "Intervallo da 0 a 255",
  Turquoise: "Turchese",
  Green: "Verde",
  Blue: "Blu",
  Purple: "Viola",
  "Navy Blue": "Blu marino",
  "Dark Turquoise": "Turchese scuro",
  "Dark Green": "Verde scuro",
  "Medium Blue": "Blu medio",
  "Medium Purple": "Viola medio",
  "Midnight Blue": "Blu notte",
  Yellow: "Giallo",
  Orange: "Arancione",
  Red: "Rosso",
  "Light Gray": "Grigio chiaro",
  Gray: "Grigio",
  "Dark Yellow": "Giallo scuro",
  "Dark Orange": "Arancione scuro",
  "Dark Red": "Rosso scuro",
  "Medium Gray": "Grigio medio",
  "Dark Gray": "Grigio scuro",
  "Light Green": "Verde chiaro",
  "Light Yellow": "Giallo chiaro",
  "Light Red": "Rosso chiaro",
  "Light Purple": "Viola chiaro",
  "Light Blue": "Blu chiaro",
  "Dark Purple": "Viola scuro",
  "Dark Blue": "Blu scuro",
  Black: "Nero",
  White: "Bianco",
  "Switch to or from fullscreen mode": "Passa alla o dalla modalità a schermo intero",
  "Open help dialog": "Apri finestra di aiuto",
  history: "cronologia",
  styles: "stili",
  formatting: "formattazione",
  alignment: "allineamento",
  indentation: "rientro",
  Font: "Font",
  Size: "Dimensione",
  "More...": "Altro...",
  "Select...": "Seleziona...",
  Preferences: "Preferenze",
  Yes: "Sì",
  No: "No",
  "Keyboard Navigation": "Navigazione da tastiera",
  Version: "Versione",
  "Code view": "Visualizzazione codice",
  "Open popup menu for split buttons": "Apri menu popup per pulsanti divisi",
  "List Properties": "Proprietà lista",
  "List properties...": "Proprietà lista...",
  "Start list at number": "Inizia lista dal numero",
  "Line height": "Altezza riga",
  "Dropped file type is not supported": "Il tipo di file trascinato non è supportato",
  "Loading...": "Caricamento...",
  "ImageProxy HTTP error: Rejected request": "Errore HTTP ImageProxy: Richiesta rifiutata",
  "ImageProxy HTTP error: Could not find Image Proxy":
    "Errore HTTP ImageProxy: Impossibile trovare Image Proxy",
  "ImageProxy HTTP error: Incorrect Image Proxy URL":
    "Errore HTTP ImageProxy: URL Image Proxy non corretto",
  "ImageProxy HTTP error: Unknown ImageProxy error":
    "Errore HTTP ImageProxy: Errore ImageProxy sconosciuto",
});

addI18n("pt", {
  Redo: "Refazer",
  Undo: "Desfazer",
  Cut: "Cortar",
  Copy: "Copiar",
  Paste: "Colar",
  "Select all": "Selecionar tudo",
  "New document": "Novo documento",
  Ok: "OK",
  Cancel: "Cancelar",
  "Visual aids": "Ajuda visual",
  Bold: "Negrito",
  Italic: "Itálico",
  Underline: "Sublinhado",
  Strikethrough: "Tachado",
  Superscript: "Sobrescrito",
  Subscript: "Subscrito",
  "Clear formatting": "Limpar formatação",
  Remove: "Remover",
  "Align left": "Alinhar à esquerda",
  "Align center": "Centralizar",
  "Align right": "Alinhar à direita",
  "No alignment": "Sem alinhamento",
  Justify: "Justificar",
  "Bullet list": "Lista com marcadores",
  "Numbered list": "Lista numerada",
  "Decrease indent": "Diminuir recuo",
  "Increase indent": "Aumentar recuo",
  Close: "Fechar",
  Formats: "Formatos",
  "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.":
    "Seu navegador não suporta acesso direto à área de transferência. Use os atalhos Ctrl+X/C/V.",
  Headings: "Cabeçalhos",
  "Heading 1": "Cabeçalho 1",
  "Heading 2": "Cabeçalho 2",
  "Heading 3": "Cabeçalho 3",
  "Heading 4": "Cabeçalho 4",
  "Heading 5": "Cabeçalho 5",
  "Heading 6": "Cabeçalho 6",
  Preformatted: "Pré-formatado",
  Div: "Div",
  Pre: "Pré",
  Code: "Código",
  Paragraph: "Parágrafo",
  Blockquote: "Citação",
  Inline: "Em linha",
  Blocks: "Blocos",
  "Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.":
    "O modo de colagem é agora texto simples. O conteúdo será colado como texto até que essa opção seja desativada.",
  Fonts: "Fontes",
  "Font sizes": "Tamanhos de fonte",
  Class: "Classe",
  "Browse for an image": "Procurar imagem",
  OR: "OU",
  "Drop an image here": "Solte uma imagem aqui",
  Upload: "Carregar",
  "Uploading image": "Carregando imagem",
  Block: "Bloco",
  Align: "Alinhar",
  Default: "Padrão",
  Circle: "Círculo",
  Disc: "Disco",
  Square: "Quadrado",
  "Lower Alpha": "Alfabeto minúsculo",
  "Lower Greek": "Alfabeto grego minúsculo",
  "Lower Roman": "Algarismos romanos minúsculos",
  "Upper Alpha": "Alfabeto maiúsculo",
  "Upper Roman": "Algarismos romanos maiúsculos",
  "Anchor...": "Âncora...",
  Anchor: "Âncora",
  Name: "Nome",
  ID: "ID",
  "ID should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.":
    "O ID deve começar com uma letra, seguido apenas por letras, números, hífens, pontos, dois pontos ou sublinhados.",
  "You have unsaved changes are you sure you want to navigate away?":
    "Você tem alterações não salvas. Tem certeza de que deseja sair?",
  "Restore last draft": "Restaurar rascunho",
  "Special character...": "Caractere especial...",
  "Special Character": "Caractere especial",
  "Source code": "Código-fonte",
  "Insert/Edit code sample": "Inserir/Editar amostra de código",
  Language: "Idioma",
  "Code sample...": "Exemplo de código...",
  "Left to right": "Da esquerda para a direita",
  "Right to left": "Da direita para a esquerda",
  Title: "Título",
  Fullscreen: "Tela cheia",
  Action: "Ação",
  Shortcut: "Atalho",
  Help: "Ajuda",
  Address: "Endereço",
  "Focus to menubar": "Foco na barra de menus",
  "Focus to toolbar": "Foco na barra de ferramentas",
  "Focus to element path": "Foco no caminho do elemento",
  "Focus to contextual toolbar": "Foco na barra de ferramentas contextual",
  "Insert link (if link plugin activated)": "Inserir link (se o plugin de link estiver ativado)",
  "Save (if save plugin activated)": "Salvar (se o plugin de salvar estiver ativado)",
  "Find (if searchreplace plugin activated)": "Procurar (se o plugin de busca estiver ativado)",
  "Plugins installed ({0}):": "Plugins instalados ({0}):",
  "Premium plugins:": "Plugins premium:",
  "Learn more...": "Saiba mais...",
  "You are using {0}": "Você está usando {0}",
  Plugins: "Plugins",
  "Handy Shortcuts": "Atalhos úteis",
  "Horizontal line": "Linha horizontal",
  "Insert/edit image": "Inserir/editar imagem",
  "Alternative description": "Descrição alternativa",
  Accessibility: "Acessibilidade",
  "Image is decorative": "Imagem decorativa",
  Source: "Fonte",
  Dimensions: "Dimensões",
  "Constrain proportions": "Manter proporções",
  General: "Geral",
  Advanced: "Avançado",
  Style: "Estilo",
  "Vertical space": "Espaço vertical",
  "Horizontal space": "Espaço horizontal",
  Border: "Borda",
  "Insert image": "Inserir imagem",
  "Image...": "Imagem...",
  "Image list": "Lista de imagens",
  Resize: "Redimensionar",
  "Insert date/time": "Inserir data/hora",
  "Date/time": "Data/hora",
  "Insert/edit link": "Inserir/editar link",
  "Text to display": "Texto a exibir",
  Url: "URL",
  "Open link in...": "Abrir link em...",
  "Current window": "Janela atual",
  None: "Nenhum",
  "New window": "Nova janela",
  "Open link": "Abrir link",
  "Remove link": "Remover link",
  Anchors: "Âncoras",
  "Link...": "Link...",
  "Paste or type a link": "Cole ou digite um link",
  "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?":
    "A URL inserida parece ser um endereço de e-mail. Deseja adicionar o prefixo mailto:?",
  "The URL you entered seems to be an external link. Do you want to add the required http:// prefix?":
    "A URL inserida parece ser um link externo. Deseja adicionar o prefixo http://?",
  "The URL you entered seems to be an external link. Do you want to add the required https:// prefix?":
    "A URL inserida parece ser um link externo. Deseja adicionar o prefixo https://?",
  "Link list": "Lista de links",
  "Insert video": "Inserir vídeo",
  "Insert/edit video": "Inserir/editar vídeo",
  "Insert/edit media": "Inserir/editar mídia",
  "Alternative source": "Fonte alternativa",
  "Alternative source URL": "URL da fonte alternativa",
  "Media poster (Image URL)": "Pôster de mídia (URL da imagem)",
  "Paste your embed code below:": "Cole seu código incorporado abaixo:",
  Embed: "Incorporar",
  "Media...": "Mídia...",
  "Nonbreaking space": "Espaço inquebrável",
  "Page break": "Quebra de página",
  "Paste as text": "Colar como texto",
  Preview: "Visualizar",
  Print: "Imprimir",
  "Print...": "Imprimir...",
  Save: "Salvar",
  Find: "Procurar",
  "Replace with": "Substituir por",
  Replace: "Substituir",
  "Replace all": "Substituir tudo",
  Previous: "Anterior",
  Next: "Próximo",
  "Find and Replace": "Procurar e Substituir",
  "Find and replace...": "Procurar e substituir...",
  "Could not find the specified string.": "Não foi possível encontrar a string especificada.",
  "Match case": "Diferenciar maiúsculas de minúsculas",
  "Find whole words only": "Procurar apenas palavras inteiras",
  "Find in selection": "Procurar na seleção",
  "Insert table": "Inserir tabela",
  "Table properties": "Propriedades da tabela",
  "Delete table": "Excluir tabela",
  Cell: "Célula",
  Row: "Linha",
  Column: "Coluna",
  "Cell properties": "Propriedades da célula",
  "Merge cells": "Mesclar células",
  "Split cell": "Dividir célula",
  "Insert row before": "Inserir linha antes",
  "Insert row after": "Inserir linha depois",
  "Delete row": "Excluir linha",
  "Row properties": "Propriedades da linha",
  "Cut row": "Cortar linha",
  "Cut column": "Cortar coluna",
  "Copy row": "Copiar linha",
  "Copy column": "Copiar coluna",
  "Paste row before": "Colar linha antes",
  "Paste column before": "Colar coluna antes",
  "Paste row after": "Colar linha depois",
  "Paste column after": "Colar coluna depois",
  "Insert column before": "Inserir coluna antes",
  "Insert column after": "Inserir coluna depois",
  "Delete column": "Excluir coluna",
  Cols: "Colunas",
  Rows: "Linhas",
  Width: "Largura",
  Height: "Altura",
  "Cell spacing": "Espaçamento entre células",
  "Cell padding": "Preenchimento da célula",
  "Row clipboard actions": "Ações da linha na área de transferência",
  "Column clipboard actions": "Ações da coluna na área de transferência",
  "Table styles": "Estilos de tabela",
  "Cell styles": "Estilos de célula",
  "Column header": "Cabeçalho de coluna",
  "Row header": "Cabeçalho de linha",
  "Table caption": "Legenda da tabela",
  Caption: "Legenda",
  "Show caption": "Mostrar legenda",
  Left: "Esquerda",
  Center: "Centro",
  Right: "Direita",
  "Cell type": "Tipo de célula",
  Scope: "Âmbito",
  Alignment: "Alinhamento",
  "Horizontal align": "Alinhamento horizontal",
  "Vertical align": "Alinhamento vertical",
  Top: "Topo",
  Middle: "Meio",
  Bottom: "Fundo",
  "Header cell": "Célula de cabeçalho",
  "Row group": "Grupo de linhas",
  "Column group": "Grupo de colunas",
  "Row type": "Tipo de linha",
  Header: "Cabeçalho",
  Body: "Corpo",
  Footer: "Rodapé",
  "Border color": "Cor da borda",
  Solid: "Sólido",
  Dotted: "Pontilhado",
  Dashed: "Tracejado",
  Double: "Duplo",
  Groove: "Sulcado",
  Ridge: "Crista",
  Inset: "Inserido",
  Outset: "Sobressalente",
  Hidden: "Oculto",
  "Insert template...": "Inserir modelo...",
  Templates: "Modelos",
  Template: "Modelo",
  "Insert Template": "Inserir modelo",
  "Text color": "Cor do texto",
  "Background color": "Cor de fundo",
  "Custom...": "Personalizado...",
  "Custom color": "Cor personalizada",
  "No color": "Sem cor",
  "Remove color": "Remover cor",
  "Show blocks": "Mostrar blocos",
  "Show invisible characters": "Mostrar caracteres invisíveis",
  "Word count": "Contagem de palavras",
  Count: "Contagem",
  Document: "Documento",
  Selection: "Seleção",
  Words: "Palavras",
  "Words: {0}": "Palavras: {0}",
  "{0} words": "{0} palavras",
  File: "Arquivo",
  Edit: "Editar",
  Insert: "Inserir",
  View: "Visualizar",
  Format: "Formatar",
  Table: "Tabela",
  Tools: "Ferramentas",
  "Powered by {0}": "Impulsionado por {0}",
  "Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help":
    "Área de texto rico. Pressione ALT-F9 para o menu. Pressione ALT-F10 para a barra de ferramentas. Pressione ALT-0 para ajuda.",
  "Image title": "Título da imagem",
  "Border width": "Largura da borda",
  "Border style": "Estilo da borda",
  Error: "Erro",
  Warn: "Aviso",
  Valid: "Válido",
  "To open the popup, press Shift+Enter": "Para abrir o popup, pressione Shift+Enter.",
  "Rich Text Area": "Área de texto rico",
  "Rich Text Area. Press ALT-0 for help.": "Área de texto rico. Pressione ALT-0 para ajuda.",
  "System Font": "Fonte do sistema",
  "Failed to upload image: {0}": "Falha ao carregar a imagem: {0}",
  "Failed to load plugin: {0} from url {1}": "Falha ao carregar o plugin: {0} da URL {1}",
  "Failed to load plugin url: {0}": "Falha ao carregar a URL do plugin: {0}",
  "Failed to initialize plugin: {0}": "Falha ao inicializar o plugin: {0}",
  example: "exemplo",
  Search: "Pesquisar",
  All: "Todos",
  Currency: "Moeda",
  Text: "Texto",
  Quotations: "Citações",
  Mathematical: "Matemática",
  "Extended Latin": "Latim estendido",
  Symbols: "Símbolos",
  Arrows: "Setas",
  "User Defined": "Definido pelo usuário",
  "dollar sign": "Sinal de dólar",
  "currency sign": "Sinal de moeda",
  "euro-currency sign": "Sinal de euro",
  "colon sign": "Sinal de colón",
  "cruzeiro sign": "Sinal de cruzeiro",
  "french franc sign": "Sinal de franco francês",
  "lira sign": "Sinal de lira",
  "mill sign": "Sinal de milésimo",
  "naira sign": "Sinal de naira",
  "peseta sign": "Sinal de peseta",
  "rupee sign": "Sinal de rúpia",
  "won sign": "Sinal de won",
  "new sheqel sign": "Sinal de novo shekel",
  "dong sign": "Sinal de dong",
  "kip sign": "Sinal de kip",
  "tugrik sign": "Sinal de tugrik",
  "drachma sign": "Sinal de dracma",
  "german penny symbol": "Símbolo de pfennig",
  "peso sign": "Sinal de peso",
  "guarani sign": "Sinal de guarani",
  "austral sign": "Sinal de austral",
  "hryvnia sign": "Sinal de hryvnia",
  "cedi sign": "Sinal de cedi",
  "livre tournois sign": "Sinal de livre tournois",
  "spesmilo sign": "Sinal de spesmilo",
  "tenge sign": "Sinal de tenge",
  "indian rupee sign": "Sinal de rúpia indiana",
  "turkish lira sign": "Sinal de lira turca",
  "nordic mark sign": "Sinal de marco nórdico",
  "manat sign": "Sinal de manat",
  "ruble sign": "Sinal de rublo",
  "yen character": "Caractere yen",
  "yuan character": "Caractere yuan",
  "yuan character, in hong kong and taiwan": "Caractere yuan, em Hong Kong e Taiwan",
  "yen/yuan character variant one": "Caractere yen/yuan variante um",
  Emojis: "Emojis",
  "Emojis...": "Emojis...",
  "Loading emojis...": "Carregando emojis...",
  "Could not load emojis": "Não foi possível carregar os emojis",
  People: "Pessoas",
  "Animals and Nature": "Animais e natureza",
  "Food and Drink": "Comida e bebida",
  Activity: "Atividade",
  "Travel and Places": "Viagem e lugares",
  Objects: "Objetos",
  Flags: "Bandeiras",
  Characters: "Caracteres",
  "Characters (no spaces)": "Caracteres (sem espaços)",
  "{0} characters": "{0} caracteres",
  "Error: Form submit field collision.": "Erro: colisão de campo ao enviar formulário.",
  "Error: No form element found.": "Erro: nenhum elemento de formulário encontrado.",
  "Color swatch": "Paleta de cores",
  "Color Picker": "Seletor de cores",
  "Invalid hex color code: {0}": "Código de cor hexadecimal inválido: {0}",
  "Invalid input": "Entrada inválida",
  R: "R",
  "Red component": "Componente vermelho",
  G: "G",
  "Green component": "Componente verde",
  B: "B",
  "Blue component": "Componente azul",
  "#": "#",
  "Hex color code": "Código de cor hexadecimal",
  "Range 0 to 255": "Faixa de 0 a 255",
  Turquoise: "Turquesa",
  Green: "Verde",
  Blue: "Azul",
  Purple: "Roxo",
  "Navy Blue": "Azul marinho",
  "Dark Turquoise": "Turquesa escuro",
  "Dark Green": "Verde escuro",
  "Medium Blue": "Azul médio",
  "Medium Purple": "Roxo médio",
  "Midnight Blue": "Azul meia-noite",
  Yellow: "Amarelo",
  Orange: "Laranja",
  Red: "Vermelho",
  "Light Gray": "Cinza claro",
  Gray: "Cinza",
  "Dark Yellow": "Amarelo escuro",
  "Dark Orange": "Laranja escuro",
  "Dark Red": "Vermelho escuro",
  "Medium Gray": "Cinza médio",
  "Dark Gray": "Cinza escuro",
  "Light Green": "Verde claro",
  "Light Yellow": "Amarelo claro",
  "Light Red": "Vermelho claro",
  "Light Purple": "Roxo claro",
  "Light Blue": "Azul claro",
  "Dark Purple": "Roxo escuro",
  "Dark Blue": "Azul escuro",
  Black: "Preto",
  White: "Branco",
  "Switch to or from fullscreen mode": "Alternar para ou sair do modo tela cheia",
  "Open help dialog": "Abrir a caixa de diálogo de ajuda",
  history: "histórico",
  styles: "estilos",
  formatting: "formatação",
  alignment: "alinhamento",
  indentation: "recuo",
  Font: "Fonte",
  Size: "Tamanho",
  "More...": "Mais...",
  "Select...": "Selecionar...",
  Preferences: "Preferências",
  Yes: "Sim",
  No: "Não",
  "Keyboard Navigation": "Navegação por teclado",
  Version: "Versão",
  "Code view": "Visualização de código",
  "Open popup menu for split buttons": "Abrir o menu contextual para botões divididos",
  "List Properties": "Propriedades da lista",
  "List properties...": "Listar propriedades...",
  "Start list at number": "Começar lista no número",
  "Line height": "Altura da linha",
  "Dropped file type is not supported": "Tipo de arquivo arrastado não é suportado",
  "Loading...": "Carregando...",
  "ImageProxy HTTP error: Rejected request": "Erro HTTP do ImageProxy: Solicitação rejeitada",
  "ImageProxy HTTP error: Could not find Image Proxy":
    "Erro HTTP do ImageProxy: Não foi possível encontrar o Image Proxy",
  "ImageProxy HTTP error: Incorrect Image Proxy URL":
    "Erro HTTP do ImageProxy: URL incorreta do Image Proxy",
  "ImageProxy HTTP error: Unknown ImageProxy error":
    "Erro HTTP do ImageProxy: Erro desconhecido do Image Proxy",
});
